export default __webpack_public_path__ + "static/media/github-logo.1ee5d17e.svg";